var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":_vm.color,"timeout":"3000"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v(" "+_vm._s(_vm.message)+" "),_c('v-btn',{attrs:{"text":"","color":"accent"},nativeOn:{"click":function($event){_vm.show = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }